import { render, staticRenderFns } from "./index.vue?vue&type=template&id=3b801680&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b801680",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/suifeng/Desktop/projects/2023/thShop/thShopAdmin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3b801680')) {
      api.createRecord('3b801680', component.options)
    } else {
      api.reload('3b801680', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=3b801680&scoped=true&", function () {
      api.rerender('3b801680', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/config/adConfig/index.vue"
export default component.exports